export const isExisty = (value: any) => value !== undefined && value !== null

export const isElementVerticallyOverflowing = (element: HTMLElement) => {
  return element.scrollHeight > element.clientHeight
}

export const getCurrentYear = () => {
  return new Date().getFullYear()
}
